<template>
  <div class="bg_content">
    <div class="card_panel" :class="[activeIsPhone ? 'scroll_wrapper' : '']">
      <van-row class="content" :class="[activeIsPhone ? 'scroll_content' : '']">
        <van-col :span="activeIsPhone ? 24 : 9" class="content scroll_wrapper"
          :class="[activeIsPhone ? 'clearPc' : '']">
          <van-list v-model="isLoading" :finished="true" finished-text
            van-clearfix @load="onLoad" class="content scroll_content" :class="[
              this.$store.getters['global/activeIsPhone'] ? 'clearPc' : '',
            ]">
            <van-image width="100%" height="270" lazy-load fit="cover"
              :src="cimg" />
            <p class="title">{{ cname }}</p>
            <p class="teacher">
              教师：
              <span>{{ teacher }}</span>
            </p>
            <p class="courseinfo">{{ summary }}</p>
          </van-list>
        </van-col>
        <van-col style="height: 100%;" v-if="!activeIsPhone" span="2">
          <div class="line"></div>
        </van-col>
        <van-col :span="activeIsPhone ? 24 : 13" class="right">
          <p class="module_name">{{ moduleName }}</p>
          <p class="pnumber">（{{ studentsOnlines.length }}）</p>
          <p class="ptips">课堂已开始，请各位同学做好准备。课程活动和资源将自动投影在屏幕上。</p>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Vue from 'vue';
import course from '@/api/course/index';
import '@vant/touch-emulator';
import { Lazyload, Image, Row, Col, List } from 'vant';
Vue.use(Lazyload).use(Image).use(Row).use(Col).use(List);
export default {
  name: 'homeMain',
  components: {},
  computed: {
    activeIsPhone() {
      return this.$store.getters['global/activeIsPhone'];
    },
    studentsOnlines() {
      let { studentsOnlines } = this.$store.state.course;
      if (!studentsOnlines) {
        studentsOnlines = [];
      }
      return studentsOnlines;
    },
    isTeacherOnline() {
      return this.$store.state.course.isTeacherOnline;
    }
  },
  data() {
    return {
      isLoading: false,
      cname: '',
      cimg: '',
      summary: '',
      teacher: '',
      moduleName: ''
      // groupName: "",
      // groupMember: 0,
    };
  },
  created() {},
  mounted() {
    console.log('3');
    this.getCourseData();
  },
  methods: {
    onLoad() {
      console.log('on load');
      this.isLoading = false;
      for (var i = 0; i < arr; i++) {
        series[0].data[i].value = arr[i].ex8;
      }
    },
    handleError() {},
    async getCourseData() {
      let result = await course.getCourseInfo({
        params: { courseid: [this.$store.state.course.courseId] },
        loadingText: '正在获取课程信息',
        errorFn: this.handleError
      });
      if (result && result.length) {
        const { fullname, img_url, summary, teacher } = result[0];
        this.cname = fullname;
        this.cimg = img_url || '/images/lesson_def_small.png';
        this.summary = summary;
        this.teacher = teacher;
      }
      if (!this.$store.state.auth.userinfo.userid) {
        await this.getLoginUsreinfo();
      }
      await this.ModuleData();
    },
    async getLoginUsreinfo() {
      let userinfo = await course.getLoginUserInfo({
        loadingText: '正在获取登录用户信息',
        errorFn: this.handleError
      });
      console.info('get userinfo', userinfo);
      if (userinfo) {
        let {
          firstname,
          lastname,
          userid,
          username,
          userpictureurl
        } = userinfo;
        this.$store.commit('auth/UPDATE_USERINFO', {
          firstname,
          lastname,
          userid,
          username,
          userpictureurl
        });
      }
    },
    async ModuleData() {
      let result = await course.getCourseelfInfo({
        params: { courseelfid: this.$store.state.course.instantId },
        loadingText: '正在获取模块信息',
        errorFn: this.handleError
      });
      if (result) {
        this.moduleName = result.courseelfname;
      }
      if (!this.isTeacherOnline) {
        this.$store.commit('global/setLoading', {
          flag: true,
          title: '等待连接中...'
        });
      } else {
        this.$store.commit('course/setTeacherOnline', true);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.bg_content {
  height: 100%;
  position: relative;
  padding: 50px 160px;
  z-index: 1;
  .content {
    height: 100%;
  }
  .card_panel {
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 48px;
    padding: 60px;
    overflow-y: auto;
  }
  .scroll_wrapper {
    overflow: hidden;
  }
  .scroll_content {
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    width: calc(~'100% + 20px');
  }
  .clearPc {
    height: auto;
    overflow: hidden;
  }
  .title {
    font-size: 36px;
    font-weight: bold;
    word-break: break-all;
    margin-top: 20px;
  }
  .teacher {
    margin-top: 15px;
    font-size: 14px;
    color: #333333;
    word-break: break-all;
    span {
      color: #ffbd00;
    }
  }
  .courseinfo {
    margin-top: 20px;
    color: #6c6c6c;
    font-size: 14px;
    word-break: break-all;
  }
  .line {
    width: 2px;
    height: 100%;
    background: #ddd;
    margin: 0 auto;
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex: 1;
    .module_name {
      word-break: break-all;
      color: #333333;
      font-size: 60px;
      font-weight: bold;
      text-align: center;
    }
    .pnumber {
      color: #333333;
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      margin-top: 30px;
    }
    .ptips {
      color: #6c6c6c;
      font-size: 30px;
      margin-top: 30px;
      text-align: center;
    }
  }
}
</style>
